bin.factory("BinFactory", ["$http", "$q", "authServiceFactory", "BinService", "$filter", "$location", 'DateService', 'PermissionModelService', 'ApplicationService', 'SchoolModelService',
    function ($http, $q, authServiceFactory, BinService, $filter, $location, DateService, PermissionModelService, ApplicationService, SchoolModelService) {
        var applications = [];
        var lastUpdated = 0;
        var loading;
        var currentBinAppRef = {};
        var bins = {};
        var searchText;
        var appFinYear;

        var getBinCount = function(archive)
        {
            bins.New = 0;
            bins.Future = 0;
            bins.Viewed = 0;
            bins.Consider = 0;
            bins.Appealed = 0;
            bins.Reject = 0;
            bins.Award = 0;
            bins.Unfinished = 0;
            var faculty = 0;

            if (PermissionModelService.get(authServiceFactory.getAuth().schoolID)[0]==undefined) 
                faculty = authServiceFactory.getAuth().permissions.faculty;
            else
                faculty = PermissionModelService.get(authServiceFactory.getAuth().schoolID)[0].faculty;
            let isArchive = appFinYear != DateService.getCurrentYear();

            // get count of apps in particular year
            if (appFinYear != 0 && appFinYear != undefined) {
                for (var i = 0; i < applications.length; i++) {

                    var isSelectedYear = applications[i].App_Fin_Year == appFinYear;
                    var isUnfinished = applications[i].Status_Unfinished == 1;

                    if (!(faculty == 0 && applications[i].isFaculty == 1)) {
                        if (applications[i].App_Fin_Year == (parseInt(appFinYear) + 1))
                            bins.Future++;
                        else if (applications[i].Status_New == 1 && isSelectedYear && (!isUnfinished || isArchive))
                            bins.New++;
                        else if (applications[i].Status_Viewed == 1 && isSelectedYear && (!isUnfinished || isArchive))
                            bins.Viewed++;
                        else if (applications[i].Status_Consider == 1 && isSelectedYear && (!isUnfinished || isArchive))
                            bins.Consider++;
                        else if (applications[i].Status_Award == 1 && applications[i].ActAward != 0 && isSelectedYear && (!isUnfinished || isArchive))
                            bins.Award++;
                        else if ((applications[i].Status_Reject == 1 || (applications[i].Status_Award == 1 && applications[i].ActAward == 0) ) && isSelectedYear && (!isUnfinished || isArchive))
                            bins.Reject++;
                        else if (isUnfinished)
                            bins.Unfinished++;

                        if (applications[i].Status_Appeal == 1 && isSelectedYear && (!isUnfinished || isArchive))
                            bins.Appealed++;
                    }

                }
            } 
            // get count of all archived applications
            else {
                for (var i = 0; i < applications.length; i++) {

                    if (!(faculty == 0 && applications[i].isFaculty == 1)) {
                        if (applications[i].Status_New == 1)
                            bins.New++;
                        else if (applications[i].Status_Viewed == 1)
                            bins.Viewed++;
                        else if (applications[i].Status_Consider == 1)
                            bins.Consider++;
                        else if (applications[i].Status_Award == 1 && applications[i].ActAward != 0)
                            bins.Award++;
                        else if (applications[i].Status_Reject == 1 || (applications[i].Status_Award == 1 && applications[i].ActAward == 0) )
                            bins.Reject++;

                        if (applications[i].Status_Appeal == 1)
                            bins.Appealed++;
                    }
                }
            }

            bins.Applications = bins.Award + bins.Consider + bins.New + bins.Reject + bins.Viewed;
        }

        var customFilter = function(searchText)
        {
            var returnObject = {};
            var filterFunction = function(filter)
            {
                for(var attr in BinService.filter[filter].values)
                {
                    if (BinService.filter[filter].values[attr])
                    {
                        if (returnObject[filter] === undefined)
                            returnObject[filter] = {};
                        returnObject[filter][attr] = 1;
                    }
                }
            } 

            // current year
            if (parseInt(appFinYear) == DateService.getCurrentYear() && parseInt(appFinYear) != 0) {
                returnObject.App_Fin_Year = [parseInt(appFinYear)];
            }
            // archived apps
            else if (parseInt(appFinYear) < DateService.getCurrentYear() && parseInt(appFinYear) != 0) {
                returnObject.App_Fin_Year = [parseInt(appFinYear)];
            }

            if (typeof searchText !== "undefined" && searchText.length>1)
            {
                returnObject.Names = searchText;
            }
            else if (typeof searchText !== "undefined" && searchText.length==1)
            {
                returnObject.ApplicantsNames = searchText;
            }

            if (BinService.getBin() == "Future") {
                returnObject.App_Fin_Year = appFinYear + 1;
            }
            else if (BinService.getBin() == "Appealed")
            {
                returnObject.Status_Appeal = 1;
            }
            else if (BinService.getBin() == "Viewed")
            {
                returnObject.Status_Viewed = 1;
            }
            else if (BinService.getBin() == "New")
            {
                returnObject.Status_New = 1;
            }
            else if (BinService.getBin() == "Consider")
            {
                returnObject.Status_Consider = 1;
            }
            else if (BinService.getBin() == "Award")
            {
                filterFunction("taxFilter");
            }
            else if (BinService.getBin() == "Non-Awarded")
            {

            }
            else if (BinService.getBin() == "Unfinished")
            {
                returnObject.Status_Unfinished = 1;
                for(var i = 2005; i <= appFinYear; i++) {
                    returnObject.App_Fin_Year.push(i);
                }
            }
            filterFunction("taxFilter");
            filterFunction("gradeFilter");
            filterFunction("NRFilter");
            filterFunction("SubCatsFilter");
            filterFunction("accountsFilter");
            return returnObject;
        }

        var isActiveBin = function(bin)
        {
            return (bin ==BinService.getBin())
        }

        var retrieveData = function (archive) {
            var auth = authServiceFactory.getAuth();
            var deferred = $q.defer();
            SchoolModelService.resolveData().then(function() {
                if (archive == true) {
                    var bin = $http.get("/api/school/" + auth.schoolID +  "/archive");
                    appFinYear = 0;
                }
                else {
                    var bin = $http.get("/api/school/" + auth.schoolID +  "/bin");
                    appFinYear = DateService.getCurrentYear(SchoolModelService.get()[0]);
                }
                loading = true;
                $q.all([bin]).then(function(results)
                {
                    deferred.resolve(results);
                    applications = results[0].data.applications;
                    for (var appIndex = 0; appIndex < applications.length; appIndex++)
                    {
                        applications[appIndex].ApplicantsFirstLetter = [];
                        for (var nameIndex = 0; nameIndex < applications[appIndex].Applicants.length; nameIndex++)
                        {
                            applications[appIndex].ApplicantsFirstLetter.push(
                                applications[appIndex].Applicants[nameIndex].substr(0, 1)
                            );
                        }
                    }
                    lastUpdated = new Date().getTime();
                    getBinCount(archive);
                    loading = false;
                });
            });
            return deferred.promise;
        }

        var service = {
            searchText: searchText,
            retrieveData: retrieveData,
            geAppByID: function(appID)
            {
                for(var i = 0; i < applications.length; i++)
                {
                    if (applications[i].applicationID == appID)
                        return applications[i];
                }
            },
            get: function(searchText)
            {
                var rev = "";
                var sort = BinService.getSort();
                if (sort.reverse)
                    rev = "-"

                if (sort.field.constructor === Array) { //if its an array of fields
                    var newsortfield = angular.copy(sort.field);
                    newsortfield[0] = rev + newsortfield[0];
                }
                else 
                    var newsortfield = rev + sort.field;
                
                var orderedItems = $filter('orderBy')(applications, newsortfield);

                //can't use angular filter, use custom filter (should be ORs, not ANDs)
                var filteredItems = [];
                var filter = customFilter(searchText);
                if (Object.getOwnPropertyNames(filter).length !== 0) {
                    for (let i in orderedItems) {
                        var add = true;
                        for (let f in filter) {
                            var subadd = false;
                            if(filter[f] instanceof Array) {
                                for (var filterItem in filter[f]) {
                                    if (orderedItems[i][f]== filter[f][filterItem]) {
                                        subadd = true;
                                    }
                                }
                            }
                            else if (typeof filter[f] == 'object') {
                                for (var filterItem in filter[f]) {
                                    if (orderedItems[i][f] && filter[f][filterItem]==1 && orderedItems[i][f][filterItem] && orderedItems[i][f][filterItem]==1) {
                                        subadd = true;
                                    }
                                }
                            }
                            else if (typeof orderedItems[i][f] == 'object') {
                                for (var matchItem in orderedItems[i][f]) {
                                    if (filter[f].length === 1 && orderedItems[i][f][matchItem][0] === filter[f]) {
                                        subadd = true;
                                    }
                                    else if (filter[f].length > 1 && orderedItems[i][f][matchItem].indexOf(filter[f]) > -1) {
                                        subadd = true;
                                    }
                                }
                            }
                            else if (typeof filter[f] == "string") {
                                if (orderedItems[i][f].indexOf(filter[f]) > -1) {
                                    subadd = true;
                                }
                            }
                            else {
                                if (orderedItems[i][f]==filter[f]) {
                                    subadd = true;
                                }
                            }
                            add &= subadd;
                        }
                        if (add) filteredItems.push(orderedItems[i]);
                    }
                }
                else {
                    filteredItems = orderedItems;
                }
                
                var items = [];
                if (BinService.getBin() == "Award")
                {
                    for (var i = 0; i < filteredItems.length; i++)
                    {
                        if ( (filteredItems[i].Status_Award == 1 && filteredItems[i].ActAward > 0))
                        {
                            items.push(filteredItems[i]);
                        }
                    }
                }
                else if (BinService.getBin() == "Non-Awarded")
                {
                    for (var i = 0; i < filteredItems.length; i++)
                    {
                        if ( (filteredItems[i].Status_Award == 1 && filteredItems[i].ActAward == 0) || (filteredItems[i].Status_Reject == 1) )
                        {
                            items.push(filteredItems[i]);
                        }
                    }
                }
                else {
                    items = filteredItems;
                }
                return items;
            },
            getLastUpdated: function()
            {
                return lastUpdated;
            },
            getLoading: function()
            {
                return loading;
            },
            currentBinAppRef: currentBinAppRef,
            getBinCount: getBinCount,
            bins: bins,
            customFilter: customFilter,
            isActiveBin: isActiveBin,
            getApplications: function()
            {
                return applications;
            },
            setAppFinYear: function(appFinYe, archive)
            {
                appFinYear = appFinYe;
                getBinCount(archive);
            },
            getAppFinYear: function()
            {
                return appFinYear;
            },
            isArchive: function()
            {
                var isArchive = false; 
                if (ApplicationService.getAwardData() !== undefined)
                    isArchive = ApplicationService.getAwardData().isArchive;
                return ($location.$$path.indexOf("/schoolside/archive") > -1 || (authServiceFactory.unlocked == 0) || (authServiceFactory.getAuth().permissions.readOnly==1) || isArchive); 
            },
            isArchiveNav: function()
            {
                return ($location.$$path.indexOf("/schoolside/archive") > -1);
            }
        };
        return service;
    }]);